// extracted by mini-css-extract-plugin
export default {"collaborator-icon":"_2Wz8aNFfyh","collaboratorIcon":"_2Wz8aNFfyh","hint":"UTEk7I3Idm"};
    if(module.hot) {
      // 1633091720619
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  